import { apiFetch } from '@/api/client'

export const notificationsApi = {
  list: (workspaceId, params, { signal } = {}) =>
    apiFetch(`workspaces/${workspaceId}/notifications`, { params, signal }),
  markRead: (workspaceId, id) =>
    apiFetch(workspaceId ? `workspaces/${workspaceId}/notifications/${id}/read` : `notifications/${id}/read`, {
      method: 'POST',
    }),
  markAllRead: (workspaceId) =>
    apiFetch(`workspaces/${workspaceId}/notifications/mark-all-read`, { method: 'POST' }),
}
